import { Any, JsonObject, JsonProperty } from 'json2typescript';
import { NewsUserState } from './news-user-state.model';
import { NewsReward } from './news-reward.model';

@JsonObject('NewsUser')
export class NewsUser {

  @JsonProperty('news_id', Number)
  newsId: number = 0;

  @JsonProperty('news_predefined_id', Any)
  newsPredefinedId: number | null = null;

  @JsonProperty('title', Any)
  title: string = '';

  @JsonProperty('summary', Any)
  summary: string = '';

  @JsonProperty('content', Any)
  content: string = '';

  @JsonProperty('is_rate', Any)
  isRate: boolean = false;

  @JsonProperty('state', NewsUserState)
  state: NewsUserState | null = null;

  @JsonProperty('rewards', [NewsReward])
  rewards: NewsReward[] = [];
}
